import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix Leaflet's default icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

// MapController to update the map view
function MapController({ locations }) {
  const map = useMap();
  
  React.useEffect(() => {
    if (locations && locations.length > 0) {
      const bounds = new L.LatLngBounds();
      locations.forEach(location => {
        if (location.gps) {
          bounds.extend([location.gps.latitude, location.gps.longitude]);
        }
      });
      
      if (bounds.isValid()) {
        map.fitBounds(bounds);
      }
    }
  }, [locations, map]);
  
  return null;
}

function MapTest() {
  const [locations, setLocations] = useState([]);
  const [jsonText, setJsonText] = useState(`[
  {
    "name": "Neufeldstrasse 2, 8008 Zürich, Switzerland",
    "type": "accommodation",
    "gps": {
      "latitude": 47.3549,
      "longitude": 8.5538
    }
  },
  {
    "name": "Technoramastrasse 1, 8404 Winterthur, Switzerland",
    "type": "attraction",
    "gps": {
      "latitude": 47.5134,
      "longitude": 8.7246
    }
  },
  {
    "name": "Rhine Falls, 8212 Neuhausen am Rheinfall, Switzerland",
    "type": "attraction",
    "gps": {
      "latitude": 47.6769,
      "longitude": 8.6152
    }
  },
  {
    "name": "Nordstrasse 8, 8852 Pfäffikon SZ, Switzerland",
    "type": "attraction",
    "gps": {
      "latitude": 47.2028,
      "longitude": 8.7726
    }
  },
  {
    "name": "Niederdorf, Zurich Old Town",
    "type": "attraction",
    "gps": {
      "latitude": 47.3740,
      "longitude": 8.5435
    }
  },
  {
    "name": "Bahnhofplatz 1, 6003 Luzern, Switzerland",
    "type": "attraction",
    "gps": {
      "latitude": 47.0507,
      "longitude": 8.3102
    }
  }
]`);
  const [error, setError] = useState('');

  const handleLoadLocations = () => {
    try {
      const parsedLocations = JSON.parse(jsonText);
      setLocations(parsedLocations);
      setError('');
    } catch (err) {
      setError('Invalid JSON: ' + err.message);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Map Test Page</h2>
      
      <div style={{ marginBottom: 20 }}>
        <h4>Enter Locations JSON</h4>
        <textarea 
          value={jsonText} 
          onChange={(e) => setJsonText(e.target.value)}
          style={{ width: '100%', height: 200, fontFamily: 'monospace' }}
        />
        <div style={{ marginTop: 10 }}>
          <button onClick={handleLoadLocations}>Load Locations</button>
          {error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
        </div>
      </div>
      
      <div style={{ height: 600, width: "100%" }}>
        <MapContainer 
          center={[47.3769, 8.5417]} // Zurich
          zoom={8} 
          style={{ height: "100%", width: "100%" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          />
          <MapController locations={locations} />
          
          {locations.map((location, index) => (
            location.gps && (
              <Marker 
                key={index} 
                position={[location.gps.latitude, location.gps.longitude]}
              >
                <Popup>
                  <div>
                    <strong>{location.name}</strong>
                    <div>Type: {location.type}</div>
                    <div>Coordinates: {location.gps.latitude}, {location.gps.longitude}</div>
                  </div>
                </Popup>
              </Marker>
            )
          ))}
        </MapContainer>
      </div>
      
      <div style={{ marginTop: 20 }}>
        <h4>Loaded Locations ({locations.length})</h4>
        <ul>
          {locations.map((location, index) => (
            <li key={index}>
              {location.name} ({location.type}) - 
              {location.gps ? `${location.gps.latitude}, ${location.gps.longitude}` : 'No GPS data'}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default MapTest; 